export default [
  {
    name: 'Jaswant Mann',
    title: 'Founder',
  },
  {
    name: 'Jaskirat Mann',
    title: 'Founder',
  },
  {
    name: 'Paul Burmy',
    title: 'Founder',
  },
  {
    name: 'Amar Burmy',
    title: 'Founder',
  },
];



// WEBPACK FOOTER //
// ./src/data/team.js